import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const opnsense = defineConnector({
  identifier: "opnsense",
  name: "OPNsense",
  tagLine: "Open-source firewall and routing platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    basicAuth({
      username: app.config.apiKey,
      password: app.secret.apiSecret,
    }),
  steps: [
    {
      title: "Enter your OPNsense details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://opnsense.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your OPNsense firewall.",
        },
      ],
    },
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In OPNsense, go to **System → Access → Users**, edit your user, and create a new **API key**. Download the key file containing the key and secret.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "configuration", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/core/firmware/status`,
  },
});
